import React, { useState, useCallback } from 'react';

// A pop-up that can be dragged by its header: put `style` on the pop-up box and
// `onHeaderMouseDown` on its title bar (give the bar a move cursor). Pressing on a
// button / field inside the bar does not start a drag. Call `reset()` when the pop-up
// opens so it starts centred again.
export function useDragOffset() {
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const onHeaderMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button !== 0 || (e.target as HTMLElement).closest('button, input, a, select, textarea')) return;
    e.preventDefault();
    const startX = e.clientX - offset.x;
    const startY = e.clientY - offset.y;
    const move = (ev: MouseEvent) => setOffset({ x: ev.clientX - startX, y: ev.clientY - startY });
    const up = () => { window.removeEventListener('mousemove', move); window.removeEventListener('mouseup', up); };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  }, [offset]);
  const reset = useCallback(() => setOffset({ x: 0, y: 0 }), []);
  return { style: { transform: `translate(${offset.x}px, ${offset.y}px)` } as React.CSSProperties, onHeaderMouseDown, reset };
}
